import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/core/services/alert.service';
import { PrescriptionService } from 'src/core/services/prescription.service';
import { ShippingService } from 'src/core/services/shipping.service';
import { UtilsService } from 'src/core/services/utils.service';
import { Order, TrackingDetails } from 'src/interfaces/order';

interface DialogData {
  order: Order;
  title: string;
  message: string;
}

@Component({
    selector: 'app-order-track-dialog',
    templateUrl: './order-track-dialog.component.html',
    styleUrls: ['./order-track-dialog.component.scss'],
    standalone: false
})
export class OrderTrackDialogComponent implements OnInit {

  trackingDetails: TrackingDetails[] = [];
  order: Order | null = null;

  constructor(
    public _dialogRef: MatDialogRef<OrderTrackDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _shippingService: ShippingService,
    public utilService: UtilsService,
    private _prescriptionService: PrescriptionService,
    private _alertService: AlertService
  ) { }

  ngOnInit(): void {

    this.order = this.data.order;

    if(!this.order.shipping_details.tracking_details) return;

    if(this.order.shipping_details.tracking_details){

      this.trackingDetails = this.order.shipping_details.tracking_details;
      this.trackingDetails
      .sort((a: TrackingDetails, b: TrackingDetails) => {
        const dateA = new Date(a.tracking.dateAndTime);
        const dateB = new Date(b.tracking.dateAndTime);

        return dateB.getTime() - dateA.getTime();
      });
    }
    else this.refresh();
    
   
  }

  get trackingDetailsIsEmpty(): boolean {
    return this.trackingDetails.length === 0;
  }


  async refresh() {

    if(!this.order) {
      this._alertService.errorAlert("An error occured retrieving order");
      return;
    }

    this.order = await this._prescriptionService.getOrder(this.order.id);

    if(!this.order) {
      this._alertService.errorAlert("Could not retrieve order");
      return;
    }

    if(!this.order.shipping_details.tracking_details) return;

    if(this.order.shipping_details.tracking_details){
      this.trackingDetails = this.order.shipping_details.tracking_details;
      this.trackingDetails
      .sort((a: TrackingDetails, b: TrackingDetails) => {
        const dateA = new Date(a.tracking.dateAndTime);
        const dateB = new Date(b.tracking.dateAndTime);

        return dateB.getTime() - dateA.getTime();
      });
    }
  }

  get latestDetails(): TrackingDetails | null {
    if(this.trackingDetails.length === 0) return null;
    
    return this.trackingDetails[0];
  }




}
